import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { message } from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Amap, CircleMarker } from "@amap/amap-react";
import moment from "moment";
import DeviceApi from "../../../../../../../api/DeviceApi";
import StringUtils from "../../../../../../../util/StringUtils";
import { DeviceStatusUtils } from "../../../../../../../components/ui-components/device-status/DeviceStatus";
import { DeviceInformationWrapper, DeviceLocationMapWrapper, InfoColumn, InfoGroup, InfoGroupContent, InfoGroupSeparator, InfoItem, InfoLabel, InfoValue, DeviceMetricChartsMapWrapper } from "./DeviceInformation.styled";
import { DeviceMetricsCharts } from "./../device-metrics-charts/DeviceMetricsCharts";
import MapPosition from "../../../../../../../components/ui-components/map-position/MapPosition";

interface DeviceInformationProps {
    deviceView: any
}

export const DeviceInformation: React.FC<DeviceInformationProps> = (props)=> {
    // params
    let latestHeartBeatMetric = props.deviceView.latestHeartBeatMetric;
    let mapCenter = (latestHeartBeatMetric?.longitude == null ||  latestHeartBeatMetric?.latitude == null) ? [116, 39]: [latestHeartBeatMetric.longitude, latestHeartBeatMetric.latitude];

    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [deviceView, setDeviceView] = useState(props.deviceView);
  

    // events

    // utils
    let formatDateTime = (timestamp: number | string)=> {
        timestamp = Number(timestamp);
        return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    }

    // render
    return (
        <DeviceInformationWrapper>
                {contextHolder}
            <InfoGroup>
                <InfoGroupContent>
                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>设备状态:</InfoLabel>
                            {
                                deviceView.device.status == 'ONLINE'
                                ? <InfoValue><CheckCircleFilled style={{color: 'green', marginRight: '10px'}}/>在线</InfoValue>
                                : <InfoValue><CloseCircleFilled style={{color: 'grey', marginRight: '10px'}} />离线</InfoValue>
                            }
                        </InfoItem>
                        
                        {deviceView.device.status == 'ONLINE'?
                        <a>
                            <InfoItem>
                                <InfoLabel>信号强度:</InfoLabel>
                                <InfoValue>{deviceView.latestHeartBeatMetric.rssi}dbm</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>更新时间:</InfoLabel>
                                <InfoValue>{formatDateTime(deviceView.latestHeartBeatMetric.timestamp)}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>更新数据:</InfoLabel>
                            </InfoItem>
                            <DeviceMetricChartsMapWrapper>
                                {
                                     DeviceMetricsCharts({deviceId: deviceView.device.id})
                                }
                            </DeviceMetricChartsMapWrapper>
                            
                        </a>:
                        <a>
                            <InfoItem>
                                <InfoLabel>最后在线时间:</InfoLabel>
                                <InfoValue>{formatDateTime(deviceView.latestHeartBeatMetric.timestamp)}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>最后更新数据:</InfoLabel>
                            </InfoItem>
                            <DeviceMetricChartsMapWrapper>
                                {
                                     DeviceMetricsCharts({deviceId: deviceView.device.id})
                                }
                            </DeviceMetricChartsMapWrapper>
                        </a>
                        }


                    </InfoColumn>
                </InfoGroupContent>
            </InfoGroup>
            
            <InfoGroupSeparator />

            <InfoGroup>    
                <InfoGroupContent>
                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>序列号 SN:</InfoLabel>
                            <InfoValue>{deviceView.node?.sn}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>设备编号:</InfoLabel>
                            <InfoValue>{deviceView.device.deviceNo}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>设备模板:</InfoLabel>
                            <InfoValue>{deviceView.deviceTemplate.name}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>产品型号:</InfoLabel>
                            <InfoValue>{deviceView.product?.modelName || deviceView.node?.model}</InfoValue>
                        </InfoItem>
                         <InfoItem>
                            <InfoLabel>固件版本:</InfoLabel>
                            <InfoValue>Ver {deviceView.node?.firmwareVersion}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>运营商:</InfoLabel>
                            <InfoValue>{deviceView.node?.oper}</InfoValue>
                        </InfoItem>
                         <InfoItem>
                            <InfoLabel>ICCID:</InfoLabel>
                            <InfoValue>{deviceView.node?.iccid}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>IMEI:</InfoLabel>
                            <InfoValue>{deviceView.node?.imei}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>备注:</InfoLabel>
                            <InfoValue>{StringUtils.emptyToSlash(deviceView.device.remarks)}</InfoValue>
                        </InfoItem>
                    </InfoColumn>
                </InfoGroupContent>
            </InfoGroup>
            
            <InfoGroupSeparator />

            <InfoGroup>
                <InfoGroupContent>
                    <InfoColumn style={{width: '100%'}}>
                        <InfoLabel>设备位置</InfoLabel>
                        <DeviceLocationMapWrapper>
                            <MapPosition lng={mapCenter[0]} lat={mapCenter[1]} zoom={15} status={deviceView.device?.status} />
                        </DeviceLocationMapWrapper>
                    </InfoColumn>
                </InfoGroupContent>
            </InfoGroup>

            <InfoGroupSeparator />

            { deviceView.device.positioningMethod != 'MANUAL' && <InfoGroup>    
                    <InfoGroupContent>
                        <InfoColumn>
                            <InfoItem>
                                <InfoLabel>定位方式</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.altitude == null ? '基站定位': 'GNSS'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>最后位置时间</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric==null ? '未知' : formatDateTime(latestHeartBeatMetric.timestamp)}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>经度</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.longitude?.toFixed(6) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>纬度</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.latitude?.toFixed(6) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>高度</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.altitude?.toFixed(6) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>速度 (km/h)</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.speed_km?.toFixed(0) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>方向</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.course?.toFixed(2) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>卫星数量</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.satelites?.toFixed(2) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>LAC</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.lac ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>CI</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.ci ?? 'N/A'}</InfoValue>
                            </InfoItem>
                        </InfoColumn>
                    </InfoGroupContent>
                </InfoGroup>
            }

            
            { deviceView.device.positioningMethod == 'MANUAL' && <InfoGroup>
                    <InfoGroupContent>
                        <InfoColumn style={{width: 'auto', marginRight: '50px'}}>
                            <DeviceLocationMapWrapper>
                                <Amap
                                    mapStyle='amap://styles/dark'
                                    zoom={4}
                                    center={mapCenter}>
                                    
                                    {
                                        latestHeartBeatMetric && (
                                            <CircleMarker
                                                center={mapCenter} 
                                                radius={6} 
                                                fillColor={DeviceStatusUtils.getDeviceMarkerColor(deviceView.device.status)}
                                                fillOpacity={0.8} 
                                                strokeWeight={0}
                                                cursor="pointer" />
                                        )
                                    }
                                </Amap>
                            </DeviceLocationMapWrapper>
                        </InfoColumn>
                        <InfoColumn>
                            <InfoItem>
                                <InfoLabel>定位方式</InfoLabel>
                                <InfoValue>手动定位</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>经度</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.longitude?.toFixed(6) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                            <InfoItem>
                                <InfoLabel>纬度</InfoLabel>
                                <InfoValue>{latestHeartBeatMetric?.latitude?.toFixed(6) ?? 'N/A'}</InfoValue>
                            </InfoItem>
                        </InfoColumn>
                    </InfoGroupContent>
                </InfoGroup> 
            }

        </DeviceInformationWrapper>
    )
}

export default DeviceInformation;
